import React, { useEffect, useRef } from 'react';
import styles from '../styles/components/_Card.module.scss';
import InfoBlock from './InfoBlock';
import { ReactComponent as PoneyclubLogo } from '../assets/images/poneyclubup.svg';

const Card = ({
  mainImage,
  title,
  subtitle,
  dateParts,
  typePerformance,
  description,
  orientation = 'vertical',
  height,
  imagePosition = 'top',
  tags = [],
  onClick,
  showOverlay = true,
  cardColor = 'var(--white)',
  linkTo,
  customNavigate,
  additionalArtists = [],
  addInfosEvent,
  isPast = false,
}) => {
  const titleRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const adjustFontSize = () => {
      const title = titleRef.current;
      const container = containerRef.current;
      if (!title || !container) return;

      let fontSize = 24; // Starting font size
      title.style.fontSize = `${fontSize}px`;

      while (title.scrollHeight > container.clientHeight && fontSize > 12) {
        fontSize -= 0.5;
        title.style.fontSize = `${fontSize}px`;
      }
    };

    adjustFontSize();
    window.addEventListener('resize', adjustFontSize);
    return () => window.removeEventListener('resize', adjustFontSize);
  }, [title]);

  const cardClasses = `
    ${styles.card}
    ${styles[orientation]}
    ${styles[`image-${imagePosition}`]}
    ${(onClick || linkTo) ? styles.clickable : ''}
    ${isPast ? styles.past : ''}
  `;

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    } else if (linkTo && customNavigate) {
      customNavigate(linkTo);
    }
  };

  const decodeHtmlEntities = (text) => {
    if (!text) return '';
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  };

  const formattedTitle = typeof title === 'string' ? decodeHtmlEntities(title) : title;
  const formattedDescription = typeof description === 'string' ? decodeHtmlEntities(description) : description;
  const formattedSubtitle = typeof subtitle === 'string' ? decodeHtmlEntities(subtitle) : subtitle;

  return (
    <div
      className={cardClasses}
      onClick={handleClick}
      style={{
        height: height || 'auto',
        backgroundColor: cardColor,
      }}
    >
      <div className={styles.imageContainer}>
        {mainImage && (
          <img
            src={mainImage}
            alt={formattedTitle}
            className={styles.mainImage}
            loading="lazy"
            decoding="async"
            style={{
              willChange: 'transform',
              cacheControl: 'public, max-age=31536000',
            }}
          />
        )}
        {showOverlay && (
          <PoneyclubLogo
            className={styles.overlayImage}
            style={{
              fill: cardColor,
            }}
          />
        )}
      </div>
      <div className={styles.content} ref={containerRef}>
        <InfoBlock
          dateParts={dateParts}
          dateFinParts={dateParts.dateFin}
          typePerformance={typePerformance}
          title={formattedTitle}
          subtitle={formattedSubtitle}
          showVerticalLabel={false}
          additionalArtists={additionalArtists}
          addInfosEvent={addInfosEvent}
        >
          <div ref={titleRef}>{formattedTitle}</div>
        </InfoBlock>
        {formattedDescription && (
          <p className={styles.description}>{formattedDescription}</p>
        )}
        {tags.length > 0 && (
          <div className={styles.tags}>
            {tags.map((tag, index) => (
              <span key={index} className={styles.tag}>{tag}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;